import React, { useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import images from "./assets/images";
import { Nav } from "./components";

const GlobalStyle = createGlobalStyle`
  body {
    background: ${({ darkMode }) => (darkMode ? "#0e0e0e" : "#e0e0e0")};
    transition: background 1s;
    width: 100vw;
  }
  a {
    color: black;
    text-decoration: none;
  }
`;

const Container = styled.main`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
  img:last-child {
    margin-bottom: 0
  }
`;

const DarkModeButton = styled.div`
  bottom: 0;
  color: #a0a0a0;
  cursor: pointer;
  font-size: 2em;
  line-height: 21px;
  margin: 1rem;
  position: fixed;
  @media (max-width: 600px) {
    pointer-events: none;
  }
`;

const Image = styled.img`
  margin-bottom: 5em;
  opacity: 0;
  transition: opacity 0.5s;
  width: 100%;
  &.loaded {
    opacity: 1;
  }
`;

export default () => {
  const [darkMode, toggleDarkMode] = useState(false);
  return (
    <>
      <GlobalStyle darkMode={darkMode} />
      <Nav darkMode={darkMode} />
      <Container>
        {images.map(({ alt, id, src }, i) => (
            <Image
              alt={alt}
              key={`img-${i}`}
              loading="lazy"
              onLoad={(e) => e.currentTarget.classList.add('loaded')}
              src={src}
            />
        ))}
      </Container>
      <DarkModeButton
        onClick={() => toggleDarkMode(!darkMode)}
        darkMode={darkMode}
      >
        ⚘
      </DarkModeButton>
    </>
  );
};
